export default __webpack_public_path__ + "static/media/marvel-spider.054016b4.jpg";